import React from "react";
import { Feather as Icon } from 'react-web-vector-icons';

export const CheckBox = ({ value, onChange }) => {
  return (
    <div className="checkBox" onClick={() => onChange(!value)}>
      <Icon name={value ? "x-circle" : "check-circle"} color='var(--onSurfaceStrong)' size={20} />
    </div>
  )
}